import { render, staticRenderFns } from "./LnButton.vue?vue&type=template&id=730ff9b2&scoped=true&"
import script from "./LnButton.vue?vue&type=script&lang=js&"
export * from "./LnButton.vue?vue&type=script&lang=js&"
import style0 from "./LnButton.vue?vue&type=style&index=0&id=730ff9b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730ff9b2",
  null
  
)

export default component.exports